import React, { useRef } from 'react';
import classNames from 'classnames/bind';
import { useClickOutside } from '@carnica/utils/hooks';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var SidebarContent = function SidebarContent(props) {
  var children = props.children,
    className = props.className,
    position = props.position,
    rootClassName = props.rootClassName,
    style = props.style,
    animate = props.animate,
    onClickOutside = props.onClickOutside;
  var containerRef = useRef(null);
  useClickOutside({
    isActive: !!onClickOutside,
    ignoreClicksInsideRefs: [containerRef],
    onClick: onClickOutside
  });
  return /*#__PURE__*/React.createElement("aside", {
    className: cn('sidebar', rootClassName, "animate_".concat(animate), "position_".concat(position)),
    style: {
      zIndex: style === null || style === void 0 ? void 0 : style.zIndex
    }
  }, /*#__PURE__*/React.createElement("div", {
    "aria-label": "overlay",
    className: cn('overlay')
  }), /*#__PURE__*/React.createElement("section", {
    className: cn('content', "position_".concat(position), className),
    ref: containerRef
  }, children));
};